<template>
  <div class="layout-set-box">
    <div class="color-item">
      <div class="item-title">Theme</div>
      <div class="color-bar">
        <div class="sub-title">Header</div>
        <div class="color-list">
          <span
            v-for="(item, index) in color"
            :key="index"
            class="color-item"
            :style="{
              'background-color': item,
              color: index === 0 ? '#4d5259' : '#ffffff'
            }"
            @click="setTheme('head', index)"
          >
            <i v-if="index === theme.head" class="el-icon-check" />
          </span>
        </div>
      </div>
      <div class="color-bar">
        <div class="sub-title">Logo</div>
        <div class="color-list">
          <span
            v-for="(item, index) in color"
            :key="index"
            class="color-item"
            :style="{
              'background-color': item,
              color: index === 0 ? '#4d5259' : '#ffffff'
            }"
            @click="setTheme('logo', index)"
          >
            <i v-if="index === theme.logo" class="el-icon-check" />
          </span>
        </div>
      </div>
      <div class="color-bar">
        <div class="sub-title">Navigation Bar</div>
        <div class="color-list">
          <span
            v-for="(item, index) in color"
            :key="index"
            class="color-item"
            :style="{
              'background-color': item,
              color: index === 0 ? '#4d5259' : '#ffffff'
            }"
            @click="setTheme('menu', index)"
          >
            <i v-if="index === theme.menu" class="el-icon-check" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import storage from '@/utils/storage'
export default {
  name: 'LayoutSet',
  data() {
    return {
      theme: {
        head: 0,
        logo: 1,
        menu: 1
      },
      color: ['#ffffff', '#465161', '#15c377', '#48b0f7', '#faa64b', '#f96868', '#926dde', '#33cabb']
    }
  },
  created() {
    var value = storage.getLocal('theme')
    if (value && value.length > 0) this.theme = JSON.parse(value)
  },
  methods: {
    setTheme(attr, index) {
      this.theme[attr] = index
      storage.setLocal('theme', JSON.stringify(this.theme))
      this.$store.commit('SET_THEME', this.theme)
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-set-box {
  color: #333;
  padding: 10px;

  .item-title {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .sub-title {
    padding: 5px;
    font-size: 14px;
  }

  .color-bar {
    margin-bottom: 8px;

    .color-list {
      .color-item {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin: 5px;
        cursor: pointer;
        text-align: center;
        line-height: 20px;
        overflow: hidden;

        .el-icon-check {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
